export function getStoredTheme() {
  try {
    const stored = window.localStorage.getItem('theme');
    if (stored === 'light' || stored === 'dark') return stored;
  } catch (_) { /* private mode */ }
  return null;
}

export function getSystemTheme() {
  try {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) return 'dark';
  } catch (_) { /* no matchMedia */ }
  return 'light';
}

export function resolveInitialTheme() {
  return getStoredTheme() || getSystemTheme();
}

// Paints the theme only; the OS default is never written to storage.
export function applyTheme(theme) {
  try { document.documentElement.setAttribute('data-theme', theme); } catch (_) {}
}

// Called only when the user explicitly picks a theme.
export function persistTheme(theme) {
  try { window.localStorage.setItem('theme', theme); } catch (_) {}
}
